import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "redText"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    _createTextVNode(_toDisplayString(_ctx.siteTitle) + " ", 1),
    (_ctx.showDbName)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.dbName), 1))
      : _createCommentVNode("", true)
  ]))
}